import { gql } from 'apollo-angular';
import { PaymentSubscription } from '../../shared/entities/payment/payment';
import { Tenant } from '../../shared/entities/tenant/tenant';
import { TenantLicenceRequest } from '../../shared/entities/tenantLicenceRequest/tenantLicenceRequest';
import { TenantLicenceStatus } from '../../shared/entities/tenantLicenceStatus/TenantLicenceStatus';

export const SUBSCRIPTION_QUERY = gql`
query getPaymentSubscription(
  $tenantId: String
)
{
  subscription: getPaymentSubscription(
    tenantId: $tenantId
  )
  {
    state
    startDateTime
    endDateTime
    trialEndDateTime
    discount {
      amountOff
      percentOff
      duration
      durationInMonths
      currency
      name
    }
    items {
      type
      quantity
      assigned
      price
      currency
      interval
      discount {
        amountOff
        percentOff
        duration
        durationInMonths
        currency
        name
      }
    }
  }
  tenantLicenceRequests: getTenantLicenceRequests(
    filter: {
      tenantId: $tenantId,
      status: [PROCESSING],
      actionType: REMOVE
    }
  )
  {
    licenceType
    licenceCount
    paymentProviderFulfillmentDateTime
  }
  tenantLicenceRequestsStatuses: getTenantLicenceRequestsStatuses(
    filter: {
      tenantId: $tenantId,
      status: [PROCESSING]
    }
  )
  {
    isIncreaseProcessing
    isDecreaseProcessing
  }
  tenant: getTenantByTenantId(
    tenantId: $tenantId
  )
  {
    id
    hasOpenLicenceRequests
    invoiceEmail
    invoiceAddress {
      id
      name
      addressLine0
      addressLine1
      postalCode
      city
      country
      vatNumber
      vatType
    }
  }

}
`;

export interface PaymentQueryResponse {
  subscription: PaymentSubscription;
  tenant: Tenant;
  tenantLicenceRequests: TenantLicenceRequest[];
  tenantLicenceRequestsStatuses: TenantLicenceStatus[];
  loading: boolean;
}

export const DECREASE_DELETION_STATUS_QUERY = gql`
query getDecreaseDeletionStatus(
  $tenantId: String
)
{
  tenantLicenceRequestsStatuses: getTenantLicenceRequestsStatuses(
    filter: {
      tenantId: $tenantId,
      status: [PROCESSING],
      actionType: REMOVE
    }
  )
  {
    tenantLicenceRequest{
      id
    }
  }
}
`;

export interface DecreaseDeletionStatusQueryResponse {
  tenantLicenceRequestsStatuses: TenantLicenceStatus[];
  loading: boolean;
}
